module.exports = __webpack_public_path__ + "img/blovly-logo.4dae5fb3.png";